import { Component, OnInit } from '@angular/core';
// import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../service/api_service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EmpMasterModel } from '../../model'
// import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { Injectable } from '@angular/core';
import { Router } from "@angular/router"
import * as $ from 'jquery';
import { ColumnGroup } from 'ag-grid-community';
import { Subscription } from 'rxjs';
import { throwToolbarMixedModesError } from '@angular/material';
import { imageUpload } from 'server/api/ExpenseMaster/expenseMaster.controller';

@Component({
    selector: 'app-ssstatementreport',
    template: require('./ssstatementreport.component.html'),
    viewProviders: [ApiService]
})
// @Injectable({
//   providedIn: 'root',
// })
export class SSStatementReportComponent implements OnInit {
    EmpData: EmpMasterModel = new EmpMasterModel();
    empDetails: any = [];
    busy: Subscription;
    private columnDefs;
    private rowHeight;
    EmpCountDetails: any;
    api: any;
    stateList: any = [];
    headQuarterList: any = [];
    ManagerList: any
    imagePath: any;
    columnApi: any;
    empStockistData: any;
    defaultColDefine;
    private gridColumnApi;
    token: any;
    Selfi_Image: any;
    empData: any;
    fromDate: string;
    toDate: string;




    Emp_Form = new FormGroup({
        fromDate: new FormControl('', [Validators.required]),
        toDate: new FormControl('', [Validators.required]),
        stockist: new FormControl('', [Validators.required]),
        employee: new FormControl('', [Validators.required]),

    });

    // getValue(openSelfiImageModal:any){

    //     }


    //     this.modalserice.open(openSelfiImageModal)

    //   }
    // }

    static parameters = [ApiService, Router, HttpClient]
    constructor(private apiService: ApiService, private router: Router, private http: HttpClient, private modalService: NgbModal) {
        this.apiService = apiService;
        var self = this;


    }


    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        $('#filter-option').trigger('click');
        this.getState();
        this.getHeadQuarterList();
        this.getManagerDetails();
        this.EmpData.status = -1;
        this.EmpData.stateId = 0;
        this.EmpData.HQ = 0;
        this.EmpData.ManagerID = 0;
        var parent = this;
        this.getEmployee();
        this.getStockistNameDetails();
        var date = new Date();
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, "0");
        var month1 = (date.getMonth()).toString().padStart(2, "0");
        this.fromDate = year + '-' + month + '-' + "01";
        this.toDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        console.log('firstDate ', this.fromDate, this.toDate);
        this.Emp_Form.controls['fromDate'].setValue(
            this.fromDate
        );
        this.Emp_Form.controls['toDate'].setValue(
            this.toDate
        );
        this.getSSreport(this.Emp_Form.value);
        this.columnDefs = [
            // { headerName: 'Product ID', field: 'PRODUCT_ID', width: 120 },
            { headerName: 'Product Name', field: 'PRODUCT_NAME', width: 200,
            filter: 'agTextColumnFilter', 
            floatingFilterComponentParams:{
                  suppressFilterButton:true
              },
             filterParams:{
              filterOptions:['contains'],
              
              debounceMs:0,
              caseSensitive:false,
              suppressAndOrCondition:true
              }
},
            // { headerName: 'Stockist ID', field: 'Stockist_Id', width: 120 },
            { headerName: 'Stockist Name', field: 'Stockist_Name', width: 150,filter: 'agTextColumnFilter' },
            { headerName: 'Stockist Place', field: 'Stockist_Place', width: 150,filter: 'agTextColumnFilter' },
            // { headerName: 'Curever', field: 'Curever', width: 100 },
            { headerName: 'PTS ', field: 'PTS_Per_Box', width: 130,filter: 'agTextColumnFilter' },
            { headerName: 'Opening Unit', field: 'Opening_Unit', width: 130 ,filter: 'agTextColumnFilter'},
            { headerName: 'Opening Value', field: 'Opening_Value', width: 140 ,filter: 'agTextColumnFilter'},
            { headerName: 'Purchase Unit', field: 'Purchase_Unit', width: 130 ,filter: 'agTextColumnFilter'},
            { headerName: 'Purchase Value', field: 'Purchase_Value', width: 140 ,filter: 'agTextColumnFilter'},
            { headerName: 'Sale', field: 'Sale', width: 140,filter: 'agTextColumnFilter' },
            { headerName: 'Secondary value', field: 'Secondary_Value', width: 150,filter: 'agTextColumnFilter' },
            { headerName: 'Closing Stock Unit', field: 'Closing_Stock_Unit', width: 160,filter: 'agTextColumnFilter' },
            { headerName: 'Closing Stock Value', field: 'Closing_Stock_Value', width: 170,filter: 'agTextColumnFilter' },
            { headerName: 'Employee Name', field: 'SO_Name', width: 140,filter: 'agTextColumnFilter' },
            // { headerName: 'SO Code', field: 'SO_Code', width: 140 },
            { headerName: 'Manager Name', field: 'Manager_Name', width: 140,filter: 'agTextColumnFilter' },
            { headerName: 'Zone', field: 'Zone', width: 140,filter: 'agTextColumnFilter' },
            {
                headerName: 'Upload doc',
                field: 'Uploaded_Doc',
                width: 120,
                suppressMenu: true,
                suppressSorting: true,
                floatingFilterComponentParams: {
                    suppressFilterButton: true
                    },
                    menuTabs: ['generalMenuTab'],
                    cellRenderer: function (params) {
                        // console.log("Dataaaa",params.data.Uploaded_Doc)
                        var eDiv = document.createElement('div');
                        eDiv.innerHTML = '<span><button class="btn btn-primary green acceptBtn" title="View Detail" data-toggle="modal" data-target="#imagepreview" style="height: 30px; width: 30px; padding: 0px; "><img src="https://icon-library.com/images/thumbnail-icon/thumbnail-icon-4.jpg" style="width: 100%; height: 100%;" ></button></span>';
                        // var content = 'content';
                        var acpButton = eDiv.querySelectorAll('.acceptBtn')[0];
                        acpButton.addEventListener('click', function () {
                            // viewCustomerDetails(params)
                            // this.openmodal()
                            parent.imagePath = params.data.Uploaded_Doc;
                        });
                        return eDiv;
                    }
                },
                { headerName: 'Closing Month', field: 'Closing_Month', width: 140,filter: 'agTextColumnFilter' },
                { headerName: 'Stock Date', field: 'Stock_Date', width: 140,filter: 'agTextColumnFilter' },
            ];
            // this.EmpCountDetails = [
        //     {"Product_Name": "Crocin",  "Dealer_Name": "Chhabra", "Dealer_Place": "Delhi", "PTS_Per_Box": 125, "Opening_Unit": 100, "Opening_Value": 95, "Purchase_Unit": 2, "Purchase_Value": 85, "Secondary_Unit": 3, "Secondary_Value": 5, "Closing_Stock_Unit": 6, "Closing_Stock_Value": 650, "SO_Name": "Panchkula", "Manager_Name": "Nagaraja", "Zone": "Delhi", "Uploaded_Doc": "image", "Stock_Date": "12-06-2022"},
        // ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };
    }

    getState() {
        this.apiService.getState().subscribe((res: any) => {
            this.stateList = res.data;
        })
    }
    getSSreport(data) {
        this.apiService.ssreport(data).subscribe((res: any) => {
            this.EmpCountDetails = res
        })
    }
    filter() {
        this.getSSreport(this.Emp_Form.value)

    }
    getHeadQuarterList() {
        this.apiService.getHeadQuarterList().subscribe((res: any) => {
            this.headQuarterList = res.data;
        })
    }

    getManagerDetails() {
        var data = {
            Id: this.token.id
        };
        this.http.post('/api/Report/getManagerListForLogUnLog', data)
            .subscribe(res => {
                this.ManagerList = res;
            });
    }

    viewCustomerDetails(hi) {
        // this.modalService.open(uploadImage)
        console.log('hello');
    }

    InActive(event) {
        var tokenData = JSON.parse(sessionStorage.getItem("currentUser"));
        let id = tokenData.id;
        var text = $('#Status_' + event.EmpId).text();
        let status = (text == "InActive" ? 1 : 0);
        let data = { EmpId: event.EmpId, Active: status, id: id };
        this.busy = this.http.post('/api/usermasters/UpdateEmployeeStatus', data).subscribe((res: any) => {
            console.log("response", res);
            if (res.length > 0) {
                if (res[0].flag == 1) {
                    if (status == 0) {
                        $('#Status_' + event.EmpId).text("InActive");
                        $('#Status_' + event.EmpId).css('color', 'red');
                    } else {
                        $('#Status_' + event.EmpId).text("Active");
                        $('#Status_' + event.EmpId).css('color', 'green');

                    }
                } else {
                    alert(res[0].msg)
                }
            }
        })
    }
    empmaster() {
        this.router.navigate(['/addemployeemaster']);
    }


    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.hideOverlay();
    }

    onBtnExport() {
        this.api.exportDataAsExcel({ fileName: 'employeemaster' });
    }

    sizeToFit(skipHeader) {
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }

    getEmpDetails() {
        this.EmpData.empId = this.token.id;
        console.log(this.EmpData);

        this.busy = this.apiService.getEmpDetailsByFilter(this.EmpData).subscribe((res: any) => {
            console.log("response", res)
            this.empDetails = res;
            // if (this.empDetails.length > 0) {
            //   let column = Object.keys(this.empDetails[0]);
            //   console.log('columns', column);
            //   // gridOptions.api.setColumnDefs(column);
            //   let dynamicColumnDef: any = [];
            //   column.forEach(data => {
            //     let demo: any = {
            //       headerName: data.toString(),
            //       field: data.toString()
            //     };
            //     dynamicColumnDef.push(demo);

            //   });
            //   this.columnDefs = dynamicColumnDef;
            // }
        })


    }

    /* gridHeight() {
        // var height = 0;
        let windowHeight = window.innerHeight;
        let mainContentHeight = document.querySelector(".main_content").clientHeight;
        let mainContentHeaderHeight = document.querySelector(".main_content_header").clientHeight;
        document.getElementById('gridHeight').style.height = `${mainContentHeight - mainContentHeaderHeight - 60}px`;
        console.log('Window', windowHeight, 'MAIN HEIGHT', mainContentHeight, "HEADER HEIGHT", mainContentHeaderHeight);
    } */
    openmodal(cont) {
        this.modalService.open(cont)
    }
    getEmployee() {
        var data = {
            Id: this.token.id
        };
        this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.empData = res.data;
        })
    }

    getStockistNameDetails() {
        this.apiService.getStockistNameDetails().subscribe((res: any) => {
            this.empStockistData = res.data;
            console.log('stockistName', this.empStockistData)
        })
    }
}
function uploadImage(uploadImage: any) {
    throw new Error('Function not implemented.');
}

function viewCustomerDetails(data: any) {
    throw new Error('Function not implemented.');
}


function imageURL(Uploaded_Doc: any) {
    throw new Error('Function not implemented.');
}

